import { useState, useEffect } from "react";
import { Link } from "react-router";

const CategoryCollapse = ({ parentCategory, closeModal }: any) => {
    const [activeCategoryId, setActiveCategoryId] = useState<number | null>(null);

    // تنظیم اولیه: وقتی داده آمد، اولین دسته فعال باشد
    useEffect(() => {
        if (parentCategory && parentCategory.length > 0) {
            setActiveCategoryId(parentCategory[0].id);
        }
    }, [parentCategory]);


const renderSubcategories = (category: any, level: number = 1) => {
    if (!category.children || category.children.length === 0) {
        return null;
    }

    return (
        <div
            className={`ms-3 mt-2 ${level === 1 ? 'subcategory-columns' : ''}`}
            style={
                level === 1
                    ? {
                          display: 'grid',
                          gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))',
                          gridAutoFlow: 'row',
                          columnGap: '1rem',
                          rowGap: '0.5rem',
                          alignItems: 'start',
                      }
                    : undefined
            }
        >
            {category.children.map((sub: any) => (
                <div key={sub.id} className={level >= 2 ? 'mb-2 px-0 mt-1' : 'mb-2 px-0'}>
                    <Link
                        to={`/categories/${sub.slug}`}
                        className={`text-decoration-none font-medium-lg d-block ${
                            level >= 2 ? 'text-secondary small' : 'text-dark hover  mt-2 ps-3'
                        }`}
                    >
                        {sub.name}
                    </Link>
                    {/* Render children recursively */}
                    {renderSubcategories(sub, level + 1)}
                </div>
            ))}
        </div>
    );
};


    return (
        <div className="container" onMouseLeave={closeModal}>
            <div className="collapse  shadow show bg-white header-collapse w-75 position-absolute container" id="collapse-menu">
                <div className="container position-relative">
                    <div className="accordion bg-white position-relative">
                        <div className="row px-0">

                            {/* ستون چپ - دسته‌های سطح یک */}
                            <div className="col-md-3 px-0 bg-light">
                                <div className="col-place bg-light">
                                    {parentCategory.map((category: any) => (
                                        <div className="col-lg-12 bg-light my-2" key={category.id}>
                                            <h2
                                                onMouseOver={() => setActiveCategoryId(category.id)}
                                                className="accordion-header bg-light border-0"
                                            >
                                                <button
                                                    className={`btn accordion-button font-medium-lg bg-light border-0 fw-bold shadow-none ${activeCategoryId === category.id ? 'bg-white text-site' : ''
                                                        }`}
                                                >
                                                    <div className="d-flex align-items-center w-100">
                                                        <img
                                                            src={category.icon}
                                                            style={{ width: '30px', height: '30px', objectFit: 'contain' }}
                                                            alt=""
                                                        />
                                                        <div className="ms-3">{category.name}</div>
                                                    </div>
                                                </button>
                                            </h2>
                                        </div>
                                    ))}
                                </div>
                            </div>


                            {/* ستون راست - children دسته فعال */}
                            <div className="col-md-9">
                                <div className="row gap-3 py-3">
                                    {parentCategory.map((category: any) => (
                                        category.id === activeCategoryId && (
                                            <div key={category.id} className="col-12 px-2">

                                                {(!category.children || category.children.length === 0) ? (
                                                    <p className="text-muted mx-3">زیر‌دسته‌ای وجود ندارد</p>
                                                ) : (
                                                    renderSubcategories(category)
                                                )}

                                            </div>
                                        )
                                    ))}
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CategoryCollapse;
